import React, { useState, useEffect, useContext } from 'react';
import ReactModal from 'react-modal';

import FloorPlanProvider, { FloorPlanContext } from './floorPlanProvider';
import StyledFloorPlan from './floorPlan.style';

import Container from '../../layout/container/container';
import Headline from '../../atoms/headline/headline';
import Copy from '../../atoms/copy/copy';
import CloseIcon from '../../icons/close.svg';
import { useTranslations } from 'next-intl';

import { Cta, Plan, WaitingLayer } from './components';

const FloorPlan = () => {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations();

  const { loading, error, data, hoveredPlan, collapsePlan, waitingLayer, waitingLayerHeadline } =
    useContext(FloorPlanContext);

  useEffect(() => {
    ReactModal.setAppElement('#__next');
  }, []);

  const openFloorPlan = () => {
    if (!isOpen) {
      document.body.classList.add('floorPlan--is-open');
    } else {
      document.body.classList.remove('floorPlan--is-open');
      collapsePlan();
    }

    setIsOpen(!isOpen);
  };

  return (
    <>
      {!loading && !error && !data.error ? (
        <>
          <Cta onClick={openFloorPlan} aria-label={t('floorPlan.open')} />

          <StyledFloorPlan isOpen={isOpen} closeTimeoutMS={1200}>
            <button
              className="floorPlan__close"
              type="button"
              onClick={openFloorPlan}
              aria-label={t('floorPlan.close')}
            >
              <CloseIcon />
            </button>
            <Container>
              <div className="floorPlan__inner-content">
                {/* {data.floors[expandedPlan] && data.floors[expandedPlan].subline && (
                <Copy className="floorPlan__subline" small>
                  Lorem Ipsum dolor
                </Copy>
              )} */}
                <Headline className="floorPlan__headline" secondary>
                  {t('floorPlan.headline')}
                </Headline>
                <div className="floorPlan__plans">
                  <Plan variant="technic" {...data.floors.technic} />
                  <Plan variant="human" {...data.floors.human} />
                  <Plan variant="nature" {...data.floors.nature} />
                </div>
                <div className="floorPlan__plan-descriptions">
                  <Copy className="floorPlan__subline" small>
                    {data.floors[hoveredPlan] && data.floors[hoveredPlan].description
                      ? data.floors[hoveredPlan].description
                      : ''}
                  </Copy>
                </div>
              </div>
            </Container>

            {waitingLayer && (
              <WaitingLayer
                headline={waitingLayerHeadline}
                additionalInformation={data.loadingScreen.additionalInformation}
                subline={data.loadingScreen.subline}
                sublineTreasure={data.loadingScreen.sublineTreasure}
                facts={data.facts}
                variant={waitingLayer}
              />
            )}
          </StyledFloorPlan>
        </>
      ) : null}
    </>
  );
};

const FloorPlanComponent = FloorPlan;

export default ({ dataUrl }) => (
  <FloorPlanProvider dataUrl={dataUrl}>
    <FloorPlanComponent />
  </FloorPlanProvider>
);
